module.exports = __webpack_public_path__ + "static/media/aldi.36c4ad4a.svg";